// extracted by mini-css-extract-plugin
export var parcelRow = "_uk-0";